import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/app-layout/page-content.css';
import 'AppSrc/core/style/components/my-crq/my-crq.css';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import bannerImage from './home-screen-banner.jpg';
import { MyCoordinatorWorkQueue } from './mycrq-coordinator-work-queue';
import { BackAndRefresh } from '../utility/back-refresh';
// import { RequestorRecentCrqs } from './requestor-recent-crqs';



const MyCrqHomeScreenDisplay = React.memo(({
  isCoordinatorOnANetwork, network,
}) => (
  <div className="page-content-container page-content-container-home">
    <BackAndRefresh />
    <div className="page-content">
      <div
        className="home-screen-banner"
        style={{ backgroundImage: `url(${bannerImage})` }}
      />
      {isCoordinatorOnANetwork ? (
        <MyCoordinatorWorkQueue network={network} />
      ) : (
        // <RequestorRecentCrqs />
        <div>req</div>
      )}
    </div>
  </div>
));

MyCrqHomeScreenDisplay.propTypes = {
  isCoordinatorOnANetwork: PropTypes.bool,
  network: PropTypes.string,
};


/* --- HomeScreen container component --- */

// the parent components can still pass props directly to the presentational component, and mapStateToProps can access them as ownProps
// the presentational component does not know whether its props come from the parent (ownProps) or the container, the difference is only visible in mapStateToProps
const mapStateToProps = (state, ownProps) => {
  const { roles } = state.auth.user;
  const isCoordinatorOnANetwork = (roles[MOBILE] === COORDINATOR || roles[FIXED] === COORDINATOR);
  return ({
    isCoordinatorOnANetwork,
  });
};

const MyHomeScreen = withRouter(connect(
  mapStateToProps,
)(MyCrqHomeScreenDisplay));


export {
  MyCrqHomeScreenDisplay,
  MyHomeScreen,
};
